import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { LoadingService } from '../../services';
import { ChatBotV2DataService } from '../../services/chat-bot-v2/chat-bot-v2.data.service';
import { LayoutService } from '../../services/layout/layout.service';

/** Se da vuelta la lógica, la información persiste, la información nunca muere, solo se elimina por medio de alguna función.  */
@Component({
    selector: 'app-chat-bot-asesor-v2',
    templateUrl: './chat-bot-asesor-v2.component.html',
    styles: [`:host::ng-deep {mat-drawer.feedback { transform: translate3d(100%, 0, 0); }}`]
})
export class ChatBotAsesorV2Component implements AfterViewInit {

    @ViewChild('menuTop') menuTop: ElementRef<HTMLDivElement>;

    constructor(
        public chatBotV2DS: ChatBotV2DataService,
        public loadingS: LoadingService,
        private layoutS: LayoutService
    ) { }

    ngAfterViewInit(): void {
        this.layoutS.addComponentHeight(this.menuTop, 'menu-top')
    }

}